import React from 'react';
import { Link } from 'react-router-dom';

function JoinSection() {
  return (
    <section className="home-final">
      <div className="app-container">
        <div className="home-final__action">
          <Link
            className="home-final__button"
            to="/archive"
          >
            Архив мероприятий
          
          </Link>
        </div>
      </div>
    </section>
  );
}

export default JoinSection;